import { Container, Heading, Paragraph } from "./styles";

type Props = {
  heading?: any;
  paragraph?: any;
};

const BulletPoint: React.FC<Props> = (props) => {
  const { heading, paragraph } = props;
  if (typeof heading !== "string") return null;
  if (typeof paragraph !== "string") return null;

  return (
    <Container>
      <Heading as="p">{heading}</Heading>
      <Paragraph>{paragraph}</Paragraph>
    </Container>
  );
};

export default BulletPoint;
